<template>
    <Teleport to="body">
        <Transition name="modal-fade">
            <div v-if="showModal"
                 class="modal-mask"
                 @click="closeModal"
            >
                <div class="modal-placeholder" @click.stop="">
                    <header
                        class="modal-header"
                    >
                        <slot name="header">
                            <h3>{{ t(title) }}</h3>
                        </slot>
                        <ModalCloseButton/>
                    </header>
                    <div class="inner" :style="style">
                        <component
                            ref="dynamicChild"
                            :is="mountedComponent"
                            :config="config"
                            :eventData="eventData"
                            :eventBus="$root"
                        />
                    </div>
                </div>
            </div>
        </Transition>
    </Teleport>
</template>

<script>

import Teleport from 'vue2-teleport';
import ModalCloseButton from "@/components/modal/type/ModalCloseButton.vue";

export default {
    components: {ModalCloseButton, Teleport},
    data() {
        return {
            title: '',
            showModal: false,
            mountedComponent: null,
            config: {},
            eventData: null,
            style: {},
        };
    },
    mounted() {
        this.$root.$on('openModal', (component, modalConfig, componentConfig, eventData) => {
            this.openModal(component, modalConfig, componentConfig, eventData);
        });
        this.$root.$on('closeModal', this.closeModal);
    },
    methods: {
        keydownListener(event) {
            if ('Escape' === event.key) {
                this.closeModal();
            }
        },
        openModal(component, modalConfig, componentConfig, eventData) {
            document.addEventListener('keydown', this.keydownListener);
            this.showModal = true;
            const body = document.body;
            this.title = modalConfig['title'] || '';

            if (body) {
                body.style.overflow = 'hidden';
            }

            this.config = componentConfig;
            this.eventData = eventData;
            this.style = modalConfig['style'];
            this.mountedComponent = component;
        },
        async closeModal(event) {
            if (event && event.type === 'mouseup') {
                return
            }

            const componentChild = this.$refs.dynamicChild;
            let canClose = true;

            if (typeof componentChild.canCloseModal === 'function') {
                canClose = await componentChild.canCloseModal();
            }

            if (canClose) {
                return this.exitModal();
            }

        },
        exitModal() {
            document.removeEventListener('keydown', this.keydownListener);
            this.showModal = false;
            const body = document.body;

            if (body) {
                body.style.overflow = 'auto';
            }

            this.mountedComponent = null;
            this.config = null;
            this.style = null;
            this.$emit('close');
        }
    }
};

</script>

<style lang="sass" scoped>
@import "src/assets/scss/variable.scss";
.modal-mask {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 900;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.3);
    display: grid;
    place-items: center;
}

.modal-placeholder {
    background-color: white;
    border-radius: 1rem;
    position: relative;
    padding-bottom: 10px;
}

.modal-header {
    text-align: left;
    position: relative;
    border-bottom: 1px solid #eeeeee;
    color: #eeeeee;
    justify-content: space-between;
    background-color: $main-background-color;
    border-radius: 1rem 1rem 0 0;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
    opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
    transition: 0.25s ease all;
}

.inner {
    position: relative;
    padding: 15px;
    overflow: auto;
    display: flex;
    max-height: 950px;
    max-width: 950px;
}

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}
</style>


// WEBPACK FOOTER //
// ModalFactory.vue?4dc30f47